/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SessionUrlResponse = {
  sessionId: string;
  url: string;
};

/** @internal */
export const SessionUrlResponse$inboundSchema: z.ZodType<
  SessionUrlResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  url: z.string(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
  });
});
/** @internal */
export type SessionUrlResponse$Outbound = {
  session_id: string;
  url: string;
};

/** @internal */
export const SessionUrlResponse$outboundSchema: z.ZodType<
  SessionUrlResponse$Outbound,
  z.ZodTypeDef,
  SessionUrlResponse
> = z.object({
  sessionId: z.string(),
  url: z.string(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
  });
});

export function sessionUrlResponseToJSON(
  sessionUrlResponse: SessionUrlResponse,
): string {
  return JSON.stringify(
    SessionUrlResponse$outboundSchema.parse(sessionUrlResponse),
  );
}
export function sessionUrlResponseFromJSON(
  jsonString: string,
): SafeParseResult<SessionUrlResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SessionUrlResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SessionUrlResponse' from JSON`,
  );
}
